import { render, staticRenderFns } from "./pageMessage.vue?vue&type=template&id=099001b3&scoped=true"
import script from "./pageMessage.vue?vue&type=script&lang=js"
export * from "./pageMessage.vue?vue&type=script&lang=js"
import style0 from "./pageMessage.vue?vue&type=style&index=0&id=099001b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099001b3",
  null
  
)

export default component.exports